import React, { Children } from 'react';
import { Layout } from '../components/layout/Layout';
import { motion } from 'framer-motion';
import { Heart, Mail, DollarSign } from 'lucide-react';
export function GivePage() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24
      }
    }
  };
  return <Layout data-id="element-540">
      {/* Hero Section */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-541">
        <div className="absolute inset-0 opacity-20" data-id="element-542">
          <img src="https://images.unsplash.com/photo-1438232992991-995b7058bbb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Worship Background" className="w-full h-full object-cover" data-id="element-543" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-544" />

        <div className="container-custom relative z-10" data-id="element-545">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-6xl font-serif font-bold mb-6" data-id="element-546">
            Give
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-547">
            Your generosity helps us continue our mission to reach people with
            the love of Christ and serve our community.
          </motion.p>
        </div>
      </div>

      {/* Ways to Give Section */}
      <section className="py-24 bg-[#F5F7FA]" data-id="element-548">
        <div className="container-custom" data-id="element-549">
          <div className="text-center mb-16" data-id="element-550">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0A1F44] mb-4" data-id="element-551">
              Ways to Give
            </h2>
            <div className="h-1 w-20 bg-[#C8102E] mx-auto rounded-full" data-id="element-552" />
          </div>

          {/* Cards Grid */}
          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: '-100px'
        }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto" data-id="element-553">
            {/* CashApp */}
            <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#00D632] flex flex-col items-center justify-center min-h-[240px]" data-id="element-554">
              <div className="w-16 h-16 bg-[#00D632]/10 rounded-full flex items-center justify-center text-[#00D632] mb-6" data-id="element-555">
                <DollarSign className="w-8 h-8" strokeWidth={2.5} data-id="element-556" />
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-557">CashApp</h3>
              <p className="text-lg font-bold text-gray-700 bg-gray-50 px-4 py-2 rounded-lg w-full" data-id="element-558">
                $Thehousehold
              </p>
            </motion.div>

            {/* PayPal */}
            <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#003087] flex flex-col items-center justify-center min-h-[240px]" data-id="element-559">
              <div className="h-16 flex items-center justify-center mb-6" data-id="element-560">
                <span className="text-4xl font-bold text-[#003087] italic tracking-tight" data-id="element-561">
                  <span className="text-[#0079C1]" data-id="element-562">Pay</span>Pal
                </span>
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-563">PayPal</h3>
              <p className="text-sm font-bold text-gray-700 bg-gray-50 px-4 py-3 rounded-lg w-full break-all" data-id="element-564">
                paypal.me/thehousehold
              </p>
            </motion.div>

            {/* Zelle */}
            <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#6D1ED4] flex flex-col items-center justify-center min-h-[240px]" data-id="element-565">
              <div className="h-16 flex items-center justify-center mb-6" data-id="element-566">
                <span className="text-4xl font-bold text-[#6D1ED4] tracking-tight" data-id="element-567">
                  Zelle<sup className="text-sm" data-id="element-568">®</sup>
                </span>
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-4" data-id="element-569">Zelle</h3>
              <div className="text-sm font-bold text-gray-700 bg-gray-50 px-4 py-3 rounded-lg w-full space-y-1" data-id="element-570">
                <p className="break-all" data-id="element-571">householdchurch1@gmail.com</p>
                <p className="text-gray-400 font-medium text-xs uppercase" data-id="element-572">
                  or
                </p>
                <p data-id="element-573">301-996-6907</p>
              </div>
            </motion.div>

            {/* Mail */}
            <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#C8102E] flex flex-col items-center justify-center min-h-[240px]" data-id="element-574">
              <div className="w-16 h-16 bg-[#C8102E]/10 rounded-full flex items-center justify-center text-[#C8102E] mb-6" data-id="element-575">
                <Mail className="w-8 h-8" strokeWidth={2} data-id="element-576" />
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-4" data-id="element-577">Mail</h3>
              <div className="text-sm text-gray-700 bg-gray-50 px-4 py-3 rounded-lg w-full" data-id="element-578">
                <p className="font-bold text-[#0A1F44]" data-id="element-579">The Household</p>
                <p data-id="element-580">1221 Caraway CT; #1090</p>
                <p className="mb-2" data-id="element-581">Largo MD 20774</p>
                <p className="text-xs text-gray-500 leading-tight" data-id="element-582">
                  Send Check or Money order to the Address Above Via mailing.
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-24 bg-[#0A1F44] text-white text-center relative z-10" data-id="element-583">
        <div className="container-custom" data-id="element-584">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-585">
            <Heart className="w-12 h-12 mx-auto mb-8 text-[#C8102E]" fill="currentColor" data-id="element-586" />
          </motion.div>

          <motion.blockquote initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-2xl md:text-3xl lg:text-4xl font-serif italic max-w-4xl mx-auto leading-relaxed text-white/90" data-id="element-587">
            "Each of you should give what you have decided in your heart to
            give, not reluctantly or under compulsion, for God loves a cheerful
            giver."
          </motion.blockquote>

          <motion.cite initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="block mt-8 text-[#C8102E] font-medium not-italic uppercase tracking-widest text-sm md:text-base" data-id="element-588">
            — 2 Corinthians 9:7
          </motion.cite>
        </div>
      </section>
    </Layout>;
}